import React from 'react';

const RecurrentIcon = (props) => {

  const { size, color, className, onClick } = props;

  return (
        <div className={className} onClick={onClick}>
            <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 13.3889L6.287 17.5399L9.492 13.7029" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M26.4998 17.7019L23.7138 13.5509L20.5078 17.3879" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M23.6768 14.0419C24.015 16.1849 23.5327 18.3766 22.3262 20.1798C21.1198 21.9829 19.2778 23.2649 17.1678 23.7699C15.7654 24.1012 14.3017 24.0706 12.9144 23.6809C11.527 23.2911 10.2615 22.5551 9.23682 21.5419" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.29185 16.9829C6.00867 15.8473 5.95348 14.6669 6.12947 13.5098C6.30546 12.3528 6.70915 11.2422 7.31716 10.2422C7.92518 9.24217 8.72546 8.37266 9.6717 7.68396C10.6179 6.99526 11.6914 6.50103 12.8298 6.22987C14.3264 5.87498 15.8913 5.93323 17.3573 6.39837C18.8234 6.86351 20.1356 7.7181 21.1538 8.87087" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>
    );
}

export default RecurrentIcon;